import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import * as Sentry from '@sentry/angular-ivy';

import { ProblemDetails } from '@api-open';

import { ResponseError } from './response-error';

function isProblemDetails(errorBody: ProblemDetails | unknown): errorBody is ProblemDetails {
  return !!errorBody && !!errorBody['detail'];
}

function getErrorResponseMessage(errorResponse: HttpErrorResponse): string {
  const errorDetails: ProblemDetails | string | undefined = errorResponse.error;

  if (isProblemDetails(errorDetails) && errorDetails.detail) {
    return errorDetails.detail;
  }

  if (typeof errorDetails === 'string') {
    return errorDetails;
  }

  return errorResponse.message;
}

export function logError(request: HttpRequest<unknown>, errorResponse: HttpErrorResponse): void {
  const responseMessage = getErrorResponseMessage(errorResponse);
  const responseError = new ResponseError(responseMessage, request.url, request.method, errorResponse.status);

  Sentry.withScope(function httpInterceptorScope(scope) {
    const fingerprint = [request.method, request.url, `${errorResponse.status}`];
    scope.setFingerprint(fingerprint);
    Sentry.captureException(responseError, { syntheticException: responseError, originalException: errorResponse });
  });
}
